<app-header></app-header>
<div class="container">
  <div class="row mt-5">
    <div class="col-12 pomodoro-concept">
      <div class="pomodoro-img">
        <img src="assets/image/blog-img.png" alt="">
      </div>
      {{ 'BlogInfo' | translate }}
    </div>
  </div>
</div>
<app-footer></app-footer>
